import { render, staticRenderFns } from "./AlertList.vue?vue&type=template&id=08eff752&scoped=true&"
import script from "./AlertList.vue?vue&type=script&lang=ts&"
export * from "./AlertList.vue?vue&type=script&lang=ts&"
import style0 from "./AlertList.vue?vue&type=style&index=0&id=08eff752&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08eff752",
  null
  
)

export default component.exports